import * as req from 'api/actions';
import * as c from './constant';

export const getNewOtherFeesList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_NEW_OTHER_FEES,
    '/api/v1/bpls/administrator/tax_revenue/other_fees',
    payload,
    callback
  );

export const getSingleNewOtherFees = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_OTHER_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}`,
    payload,
    callback
  );

export const createNewOtherFees = (payload, callback) =>
  req.create(
    c.CREATE_NEW_OTHER_FEES,
    '/api/v1/bpls/administrator/tax_revenue/other_fees',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateNewOtherFees = (id, payload, callback) =>
  req.update(
    c.UPDATE_NEW_OTHER_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeNewOtherFees = (id, payload, callback) =>
  req.remove(
    c.REMOVE_NEW_OTHER_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}`,
    payload,
    callback
  );

export const getCedulaCalculationList = (id, payload, callback) =>
  req.list(
    c.GET_CEDULA_CALCULATION_LIST,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_cedula`,
    payload,
    callback
  );

export const cedulaCalculationInfo = (id, payload, callback) =>
  req.item(
    c.CEDULA_CALCULATION_INFO,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_cedula`,
    payload,
    callback
  );

export const createCedulaFees = (id, payload, callback) =>
  req.create(
    c.CREATE_CEDULA_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_cedula`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateCalculationZoningFees = (id, zoningId, payload, callback) =>
  req.update(
    c.UPDATE_CALCULATION_ZONING_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_zoning/${zoningId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeCedulaFees = (id, newOtherFeesId, payload, callback) =>
  req.remove(
    c.REMOVE_CEDULA_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_cedula/${id}`,
    payload,
    callback
  );

export const createCalculationZoningFees = (id, payload, callback) =>
  req.create(
    c.CREATE_CALCULATION_ZONING_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_zoning`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateCedulaFees = (id, newOtherFeesId, payload, callback) =>
  req.update(
    c.UPDATE_CEDULA_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_cedula/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeCalculationZoningFees = (id, zoningId, payload, callback) =>
  req.remove(
    c.REMOVE_CALCULATION_ZONING_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_zoning/${zoningId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getVeterinaryCalculationList = (id, payload, callback) =>
  req.list(
    c.GET_VETERINARY_CALCULATION_LIST,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_veterinary_reg`,
    payload,
    callback
  );

export const createVeterinaryFees = (id, payload, callback) =>
  req.create(
    c.CREATE_VETERINARY_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_veterinary_reg`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateVeterinaryFees = (id, newOtherFeesId, payload, callback) =>
  req.update(
    c.UPDATE_VETERINARY_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_veterinary_reg/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeVeterinaryFees = (id, newOtherFeesId, payload, callback) =>
  req.remove(
    c.REMOVE_VETERINARY_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_veterinary_reg/${id}`,
    payload,
    callback
  );

export const getFireSafetyList = (payload, callback) =>
  req.list(
    c.GET_FIRE_SAFETY_LIST,
    `/api/v1/bpls/administrator/common/fee_codes`,
    payload,
    // callback,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    }
  );

export const getFireSafetyCalculation = (id, payload, callback) =>
  req.list(
    c.GET_FIRE_SAFETY_CALCULATION,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_fire_safeties`,
    payload,
    callback
  );

export const updateCalculationFireSafety = (id, payload, callback) =>
  req.create(
    c.UPDATE_CALCULATION_FIRE_SAFETY,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_fire_safeties`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getEndorsingOfficesList = (
  payload = { sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_ENDORSING_OFFICES,
    '/api/v1/bpls/administrator/endorsing_offices',
    payload,
    callback
  );

export const getTaggedBusinessLinesList = (id, payload, callback) =>
  req.list(
    c.GET_TAGGED_BUSINESS_LINES_LIST,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/tagged_business_lines`,
    payload,
    callback
  );

export const getReportAccess = (payload, callback) =>
  req.create(
    c.GET_REPORT_ACCESS,
    '/api/v1/administrators/report_access_tokens',
    payload,
    callback
  );